import axiosInstance from './api';
import { API_ROUTES } from '../config/api-routes';
import { getNotificationWebSocket } from '../utils/sockets';
import { sendProfileQuestionWsAction, supportsProfileQuestionWs } from '../utils/realtime';

export type ProfileQuestionAnswerPayload = {
  answerText?: string;
  attachment_url?: string;
  attachment_type?: string;
  attachmentFileName?: string;
};

export type ProfileQuestionApiResult = {
  success: boolean;
  message?: string;
  data?: Record<string, unknown>;
};

async function answerProfileQuestionViaWs(
  questionId: string,
  payload: ProfileQuestionAnswerPayload
): Promise<ProfileQuestionApiResult> {
  const ws = getNotificationWebSocket();
  const result = await sendProfileQuestionWsAction(ws, {
    type: 'answer_question',
    questionId,
    answerText: payload.answerText || '',
    attachment_url: payload.attachment_url,
    attachment_type: payload.attachment_type,
    attachmentFileName: payload.attachmentFileName,
  });
  return {
    success: Boolean(result.success),
    message: result.message ? String(result.message) : undefined,
    data: (result.data as Record<string, unknown>) || undefined,
  };
}

export async function answerProfileQuestion(
  questionId: string,
  payload: ProfileQuestionAnswerPayload
): Promise<ProfileQuestionApiResult> {
  if (supportsProfileQuestionWs()) {
    const ws = getNotificationWebSocket();
    if (ws) {
      try {
        return await answerProfileQuestionViaWs(questionId, payload);
      } catch {
        // Fall back to REST when the socket is unavailable or times out.
      }
    }
  }

  const { data } = await axiosInstance.post(
    API_ROUTES.MESSAGESHUB.ANSWER_QUESTION(questionId),
    payload
  );
  return data as ProfileQuestionApiResult;
}
